import { ObjetKStatusCode } from '@siclop/kstone-vue'

export class PublicHoliday extends ObjetKStatusCode {
  date: string = ''
  year: number = 0
  isRecurring: boolean = false

  constructor(data?: Partial<PublicHoliday>) {
    super(data)
    if (data) {
      this.date = data.date ?? ''
      this.year = data.year ?? 0
      this.isRecurring = data.isRecurring ?? false
    }
  }
}
